import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../../../components/default/DefaultModal';
import WarehouseStorageDataTable from '../tables/WarehouseQuoteStorageDataTable';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import useSweetAlert from '../../../../../../hooks/useSweetAlert';
import WarehouseQuoteStorageCreate from '../WarehouseStorageCreate';
import WarehouseQuoteStorageEdit from '../WarehouseStorageEdit';
import { QuoteDataForm } from '../../../../../../app/models/Quote';
import useWarehouseStorageService from '../../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { WarehouseQuoteStorage, WarehouseQuoteStorageDataForm, WarehouseQuoteStorageFilters } from '../../../../../../app/models/WareHouseQuoteStorage';
import { Depot } from '../../../../../../app/models/Depot';
import useReactConfirmAlert from '../../../../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../../../../contexts/AppContext';
import WarehouseQuoteStorageShowForm from '../forms/WareHouseStorageForms/WareHouseStorageShowForm';
import WarehouseQuoteStorageShow from '../WarehouseStorageShow';

interface Props {
    quoteId: number;
    // storages: WarehouseQuoteStorageDataForm;
    disableUpdate?: boolean;
    refresh?: number;
    isFormShow?: boolean;

}

const WarehouseQuoteStorageContainer = ({ 
    quoteId,
    disableUpdate = false,
    isFormShow = false,
     refresh,
     }: Props) => {
    const {
        getAllWarehouseQuoteStoragesByQuote,
        deleteWarehouseQuoteStorage,
        editWarehouseStorage,
        showWarehouseQuoteStorage,
        fetchingGetWarehouseQuoteStorages
    } = useWarehouseStorageService();
    const [storages, setStorages] = useState<WarehouseQuoteStorageDataForm>();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [warehouseQuoteStorages, setWarehouseQuoteStorages] = useState<WarehouseQuoteStorage[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseQuoteStorageFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);
    const [storageIdEdit, setStorageIdEdit] = useState<number>(-1);
    const [storageIdShow, setStorageIdShow] = useState<number>(-1);
    const [showStorage, setShowStorage] = useState<WarehouseQuoteStorageDataForm>({});
    const [depots, setDepots] = useState<Depot[]>([]);

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setStorageIdEdit(id);
    };
    const showShow = (id: number) => {
        setShowingShow(true);
        setStorageIdShow(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setStorageIdEdit(-1);
    };
    const hideShow = () => {
        setShowingShow(false);
        setStorageIdShow(-1);
    };

    useEffect(() => {
        if (quoteId) reloadTable();
    }, [quoteId, filter, refresh]);

    const reloadTable = () => {
        getAllWarehouseQuoteStoragesByQuote(quoteId,filter,{
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteStorages(response.data.warehouse_quote_storages);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    // const show = (id: number) => {
    //     showWarehouseQuoteStorage(id, {
    //         onSuccess: (response: ServiceResponse) => {
    //             setShowStorage(response.data.storage);
    //             setShowingShow(true);
    //         }
    //     });
    // };



    const destroy = (id: number) => {
        const message = `Está a punto de eliminar el almacenamiento #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando almacenamiento...');
                        
                        deleteWarehouseQuoteStorage(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El almacenamiento no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };
    return (
        <>
            <DefaultCard>
            <div className="h3 mt-0 mb-4 card-title">Dias libres</div> 
                <div className="row">
                    <div className="col-12">
                        {!disableUpdate && (
                        <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                        )}
                    </div>
                    <div className="col-12">
                        <WarehouseStorageDataTable
                            warehouseQuoteStorages={warehouseQuoteStorages}
                            totalRows={totalRows}
                            loading={fetchingGetWarehouseQuoteStorages}
                            show={showShow}
                            edit={showEdit}
                            destroy={destroy}
                            filter={filter}
                            setFilter={setFilter}
                            isShow={isFormShow}
                        />
                    </div>
                </div>
            </DefaultCard>

            <DefaultModal
                show={showingCreate}
                handleClose={() => setShowingCreate(false)}
                title="Crear día libre"
                showFooter={false}
            >
                <WarehouseQuoteStorageCreate
                    quoteId={quoteId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                    }}
                    onCancel={() => setShowingCreate(false)}
                />
            </DefaultModal>
            {showingEdit && (
            <DefaultModal
                show={showingEdit}
                handleClose={hideEdit}
                title="Editar día libre"
                showFooter={false}
            >
                <WarehouseQuoteStorageEdit
                storageId={storageIdEdit}
                onSaved={() => {
                    reloadTable();
                    hideEdit();
                }}
                onCancel={hideEdit}
                />
            </DefaultModal>
            )}
         {showingShow && (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información día libre"

            >
                <WarehouseQuoteStorageShow 
                storageId={storageIdShow}
                onCancel={hideShow}
                // onError={hideShow}
                />
            </DefaultModal>
            )}
        </>
    );
};

export default WarehouseQuoteStorageContainer;
